import './form-client.scss';

import { ClientFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = ClientFormSchema;
export function FormClient() {
  const { control } = useFormContext<ClientFormSchema>();
  return (
    <div id="FormClient" className="client">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="email"
        label="Email"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter email"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="address"
        label="Address"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter address"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="city"
        label="City"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter city"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="province"
        label="Province"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter province"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="contactNumber"
        label="Contact Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter contactNumber"
      />
    </div>
  );
}

export default FormClient;
